import { notifications } from "@mantine/notifications"

import { queryClient } from "~/backend/queryClient"
import {
  findOperationChainItemsQueryKey,
  useUpdateOperationChainItem,
} from "~/gen/api"
import { showAxiosError } from "~/utils/showAxiosError"

export const useUpdateOperationChainItemMutation = () =>
  useUpdateOperationChainItem({
    mutation: {
      onSuccess: async (_, variables) => {
        await queryClient.invalidateQueries(
          findOperationChainItemsQueryKey(variables.operationChainId)
        )
        notifications.show({
          title: "Success",
          message: "Operation chain item updated",
          color: "teal",
        })
      },
      onError: (error) => {
        showAxiosError({
          error,
          notificationTitle: "Failed to update operation chain item",
          showNotification: true,
        })
      },
    },
  })
